if (!customElements.get('wix-subscription-bridge')) {
  class WixSubscriptionBridge extends HTMLElement {
    connectedCallback() {
      const mapElement = this.querySelector('[data-subscription-variant-map]');
      if (!mapElement) return;

      try {
        this.variantMap = JSON.parse(mapElement.textContent);
      } catch (error) {
        console.warn('Subscription variant mapping could not be loaded.', error);
        return;
      }

      this.handleVariantChange = this.handleVariantChange.bind(this);
      document.addEventListener('product:variant-change', this.handleVariantChange);
      this.updateForVariant(this.dataset.initialVariantId);
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.handleVariantChange);
    }

    handleVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (variant) this.updateForVariant(String(variant.id));
    }

    updateForVariant(variantId) {
      const config = this.variantMap && this.variantMap[variantId];
      if (!config) return;

      const price = this.querySelector('[data-subscription-price]');
      const saving = this.querySelector('[data-subscription-saving-amount]');
      const link = this.querySelector('[data-wix-subscription-link]');

      if (price) price.textContent = config.price.replace(/,00\s*lei$/i, '').replace(/\s*lei$/i, '');
      if (saving) saving.textContent = config.saving.replace(/\s*lei$/i, '');
      if (link) link.href = config.url;
    }
  }

  customElements.define('wix-subscription-bridge', WixSubscriptionBridge);
}
